"use client";

import { Button } from "@punchup/ui-common/shadcn/ui/button";
import { SearchX } from "lucide-react";

interface VenueShowsSearchEmptyProps {
  query: string;
  onClear: () => void;
}

export default function VenueShowsSearchEmpty({
  query,
  onClear,
}: VenueShowsSearchEmptyProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-12">
      <div className="flex flex-row gap-2 items-center justify-center">
        <SearchX height={20} width={20} />
        <h3 className="text-lg text-primary-blue font-sans normal-case">
          No shows match &ldquo;{query}&rdquo;
        </h3>
      </div>
      <p className="text-sm text-secondary-blue text-center">
        Try a different keyword, or browse all upcoming shows.
      </p>
      <Button variant="link" size="sm" onClick={onClear} className="px-0">
        Clear search
      </Button>
    </div>
  );
}
